import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LendersService } from '../../services/lenders.service';
import { UserService } from 'app/core/services/user.service';
import { Result } from 'app/core/models/result';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { LendersModel } from '../../models/lenders.model';
import { LenderUserModel } from '../../models/lender-user.model';
import { NewUser } from '../../../account/models/new-user.model';
import { LenderContactModel } from '../../models/lender-contact.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-lenders-edit',
  templateUrl: './lenders-edit.component.html',
  styleUrls: ['./lenders-edit.component.css']
})
export class LendersEditComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    submitAttempt: boolean = false;
    editLenderFormGroup: FormGroup;
    //addContactFormGroup: FormGroup;
    lenderId: string;
    lender: LendersModel;
    isEditMode = false;
    lenderContacts: LenderUserModel[];
    isEmailValid: boolean;
    newUser: NewUser;
    exUser: LenderUserModel;
    lenderContact: LenderContactModel;
    showContactAddForm: boolean = false;
    showContactEditForm: boolean = false;
    showContactDetails: boolean = false;
    isDeleteMode: boolean = false;
    infoMessage: boolean = false;
    infoMessageText: string;
    hasContacts: boolean;

    constructor(
        private lendersService: LendersService,
        private accountService: UserService,
        private fb: FormBuilder,
        private location: Location,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.load();
    }

    load() {
        this.newUser = {
            isLender: true
        } as NewUser;
        this.isEmailValid = true;
        this.lenderId = this.activatedRoute.snapshot.params['id'];
        this.lendersService.get(this.lenderId).subscribe(lender => {
            this.initializeForm(lender);
            this.headerTitle = {
                title: lender.name, breadcrumbs: [
                    { title: 'Lenders', url: ['/lenders'] }
                ]
            }
            this.getContacts(lender.id);
        });
    }

    initializeForm(lender: LendersModel): void {
        this.editLenderFormGroup = this.fb.group(
            {
                id: [lender.id],
                name: [lender.name, Validators.required]
            }
        );
    }

    editLender(): void {
        this.submitAttempt = true;
        if (this.editLenderFormGroup.valid) {

            const formValue = this.editLenderFormGroup.value;
            this.lendersService.update(formValue).subscribe(
                lenderId => {
                    this.isEditMode = false;
                    this.router.navigate(['./lenders/edit/' + lenderId]);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    deleteLender() {
        this.lendersService.delete(this.lenderId).subscribe(
            result => this.router.navigate(['./lenders']),
            error => console.log(error)
        );
    }


    getContacts(lenderId: string): void {
        this.lendersService.getContacts(lenderId).subscribe(result => {
            this.lenderContacts = result;
            this.hasContacts = this.lenderContacts.length > 0
        });
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }
    toggleDeleteMode(): void {
        this.isDeleteMode = !this.isDeleteMode;
    }

    onBack(): void {
        this.location.back();
    }

    

    editLenderContact(id): void {
        this.exUser = this.lenderContacts.find(x => x.id === id);
        this.showContactDetails = false;
        this.showContactEditForm = true;
    }
    cancelEditContact(): void {
        this.showContactDetails = true;
        this.showContactEditForm = false;
        this.showContactAddForm = false;
    }

    openCannotDeleteLender(content) {
        this.modalService.open(content);
    }
}
